import { FC } from 'react'
import classnames from 'classnames'

import { Icon, Grid } from '~ui'
import Link from '~ui/Link'
import Flex from '~ui/Flex'
import Image from '~ui/Image'
import Typography from '~ui/Typography'

import styles from './SliderItem.module.scss'

const { Text } = Typography

type SliderItemProps = {
  title?: string
  subTitle?: string
  label?: string
  backgroundImage?: string
  href?: string
}

const SliderItem: FC<SliderItemProps> = ({ title, subTitle, label, href, backgroundImage }) => (
  <Link href={href}>
    <Flex className={classnames(styles['slider-item'])}>
      <div className={classnames(styles['slider-item-image-wrapper'])}>
        <Image
          src={backgroundImage}
          wrapperClassName={styles['slider-item-image']}
          className={styles['slider-item-image']}
        />
      </div>
      {label && (
        <Flex className={styles['slider-item-label']}>
          <Text size="sm">{label}</Text>
        </Flex>
      )}
      <Flex className={styles['slider-item-content']}>
        {title && (
          <Text size="lg" bold>
            {title}
          </Text>
        )}
        <Text color="g-gray-1">{subTitle}</Text>
      </Flex>
      <Grid className={styles['slider-item-button']}>
        Get Tickets
        <Icon width={14} height={14} name="chevron" />
      </Grid>
    </Flex>
  </Link>
)

export default SliderItem
